import clsx from 'clsx';
import { Image } from './Image';
import {
  PicturePasswordItemFragment,
  useGetPicturePasswordItemsQuery,
} from '@/api/types';
import { Loading } from '@pickatale/ui-kit';

interface PicturePasswordInputProps {
  passcode: Array<PicturePasswordItemFragment>;
  setPasscode: (value: Array<PicturePasswordItemFragment>) => void;
  disabled?: boolean;
}

export const PicturePasswordInput = ({
  passcode,
  setPasscode,
  disabled = false,
}: PicturePasswordInputProps) => {
  const { data, loading } = useGetPicturePasswordItemsQuery();
  if (loading) {
    return <Loading />;
  }

  const passwordItems = data?.picturePasswordItems ?? [];

  return (
    <div>
      <div className="flex justify-center">
        <div className="grid grid-cols-3 gap-6">
          {passwordItems.map((item) => (
            <button
              key={item.value}
              className={clsx(
                'flex w-32 h-32 mx-auto bg-white',
                'hover:bg-neutral-100 rounded-full text-center',
                'items-center justify-center',
                disabled ? 'cursor-not-allowed grayscale' : 'cursor-pointer',
                passcode.some((it) => it.value === item.value)
                  ? 'border-4 border-green-normal'
                  : 'border-2 border-neutral-200',
              )}
              onClick={() => setPasscode([...passcode, item])}
            >
              <Image
                className="rounded-full w-32 h-32"
                src={item.image.url.dark}
                alt={item.image.altText.translatedText}
                width={200}
                height={200}
              />
            </button>
          ))}
        </div>
      </div>

      <div className="">
        <button
          onClick={() => setPasscode([])}
          className={clsx(
            'block mx-auto my-6 px-6 py-4 text-2xl rounded-xl',
            disabled
              ? 'cursor-not-allowed bg-gray-300 text-gray-700'
              : 'cursor-pointer bg-blue-normal hover:bg-blue-dark text-white',
          )}
          disabled={disabled}
        >
          Clear
        </button>

        <div className="flex justify-center">
          <div className="grid grid-cols-3 gap-6">
            {passcode.map((item) => (
              <div
                key={item.value}
                className={clsx(
                  'flex w-16 h-16 mx-auto mb-6 bg-white',
                  'hover:bg-neutral-100 rounded-full text-center',
                  'items-center justify-center border-2 border-blue-normal',
                  disabled && 'grayscale',
                )}
              >
                <Image
                  className="rounded-full w-16 h-16"
                  src={item.image.url.dark}
                  alt={item.image.altText.translatedText}
                  width={128}
                  height={128}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
